import { StatusCode } from "../../utils/network/generated/protoTypes";
export var checkForDisconnectedByLoginError = function (path) { return function (action) {
    if (action.statusCode === StatusCode.DISCONNECT_BY_LOGIN) {
        return path;
    }
    return undefined;
}; };



//////////////////
// WEBPACK FOOTER
// ./src/features/errors/checkForDisconnectedByLoginError.ts
// module id = 1846
// module chunks = 3